<template>
    <el-dialog
        class="detail-order-sku"
        :visible.sync="detailVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Detail Order SKU"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form
                ref="detailForm"
                :model="detailForm"
                :rules="rules"
                label-width="100px"
                disabled
            >
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="Shop" prop="shop_id" size="small">
                            <el-select
                                v-model="detailForm.shop_id"
                                size="small"
                                clearable
                                filterable
                                placeholder="Placeholder Shop"
                            >
                                <el-option
                                    v-for="item in shopList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="SKU" prop="sku" size="small">
                            <el-input
                                clearable
                                size="small"
                                v-model="detailForm.sku"
                                placeholder="Please input SKU"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="Goods Name"
                            prop="name"
                            size="small"
                        >
                            <el-input
                                clearable
                                size="small"
                                v-model="detailForm.name"
                                placeholder="Please input Goods Name"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="Qty" prop="qty" size="small">
                            <el-input
                                type="number"
                                clearable
                                size="small"
                                v-model="detailForm.qty"
                                placeholder="Please input Qty"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="Price" prop="price" size="small">
                            <el-input
                                clearable
                                size="small"
                                v-model="detailForm.price"
                                placeholder="Please input Price"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="detailVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            detailForm: {
                shop_id: "",
                sku: "",
                name: "",
                price: "",
                qty: "",
            },
            rules: {
                shop_id: [
                    {
                        required: true,
                        message: "Please input shop",
                    },
                ],
                sku: [
                    {
                        required: true,
                        message: "Please input sku",
                    },
                ],
                name: [
                    {
                        required: true,
                        message: "Please select goods name",
                    },
                ],
            },
        };
    },
    methods: {
        closeDialog() {
            this.detailForm = {
                shop_id: "",
                sku: "",
                name: "",
                price: "",
                qty: "",
            };
            this.$refs["detailForm"].clearValidate();
            this.$refs["detailForm"].resetFields();
            this.$emit("update:detailVisible", false);
        },
        shopOrderSku() {
            cmofferApi
                .shopOrderSku({}, "get", this.tableItem.id)
                .then((res) => {
                    if (res) {
                        this.detailForm = {
                            ...res.data,
                        };
                    }
                })
                .catch(() => {});
        },
    },
    props: {
        detailVisible: Boolean,
        tableItem: Object,
        funcName: String,
        shopList: () => Array,
    },
    watch: {
        detailVisible(val) {
            if (val) {
                this.shopOrderSku();
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.detail-order-sku {
    .container {
        .el-select--small {
            width: 100%;
        }
    }
}
</style>
